<div class="col-md-12" style="display: flex; justify-content: space-between;">
  <h2 class="col-md-8"> Modification utilisateur </h2>
  <div class="col-md-1">
    <button  class="pull-right" mat-raised-button type="submit" color="success" (click)="validate()">Enregistrer</button>
  </div>
  <div class="col-md-1">
    <button class="pull-right" color="warn" mat-raised-button type="button" (click)="close()">
      <mat-icon>cancel</mat-icon>Fermer
    </button>
  </div>
</div>
<div class="col-md-12" *ngIf="form">
  <form focusInvalidInput [formGroup]="form">
    <div class="col-md-12" style="display: inline-flex; flex-direction: row; justify-content: flex-start; align-items: flex-start; flex-wrap: wrap;">
      <div class="col-md-4">
        <mat-form-field class="full-width">
          <mat-label>Nom</mat-label>
          <input matInput placeholder="Ex: Dupont" formControlName="nom">
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-form-field class="full-width">
          <mat-label>Prénom</mat-label>
          <input matInput placeholder="Ex: Jean-Baptiste" formControlName="prenom">
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <app-input-telephone [(phoneNumber)]="user.tel" libelle="Téléphone" (phoneNumberChange)="this.form.get('tel').setValue($event);" [parent]="form">
        </app-input-telephone>
      </div>
      <div class="col-md-4">
        <mat-form-field class="full-width">
          <mat-label>Email</mat-label>
          <input matInput placeholder="Jean-Baptiste.Dupont@veolia.com" formControlName="email">
        </mat-form-field>
      </div>
      
      <div class="col-md-4">
        <app-autocomplete-societe
            (objetChange)="onChangeSociete($event)"  
            name="societe" 
            [parent]="form"  
            libelle="Societé" 
            [objets]="societes" 
            [(objet)]="user.societe">
        </app-autocomplete-societe>
      </div>

      <div class="col-md-2">
        <mat-form-field appearance="fill">
          <mat-label>Type de profil</mat-label>
          <mat-select [(value)]="isDeleg" (selectionChange)="changedroit()">
            <mat-option [value]="false">Profil standard</mat-option>
            <mat-option [value]="true">Profil délégataire</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    
      <div class="col-md-1">

      </div>
      <div class="col-md-1">
        <mat-form-field floatLabel="always" appearance="none" class="full-width">
          <mat-label>{{form.get('actif') ? "Utilisateur Activé": "Utilisateur désactivé"}}</mat-label>
          <mat-slide-toggle formControlName="actif"></mat-slide-toggle>
          <textarea matInput hidden></textarea>
        </mat-form-field>
      </div>
    
      
    </div>
  
    <div class="row">
      <div class="col-md-3 mat-table">
        <mat-card class="table_principal">
          <mat-tree [dataSource]="dataSourceTree" [treeControl]="treeControl">
            <mat-nested-tree-node *matTreeNodeDef="let node">
              <ul>
                <li class="mat-tree-node">
                  <button mat-icon-button type="button" disabled></button>
                  {{node.code + ' ' + node.libelle}}
                  <button mat-icon-button type="button" (click)="addDroit(node)"><mat-icon>add</mat-icon></button>
                </li>
              </ul>
            </mat-nested-tree-node>
            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
              <ul>
                <li style="list-style:none">
                  <div class="mat-tree-node">
                    <button mat-icon-button type="button" [attr.aria-label]="'toggle ' + node.libelle" matTreeNodeToggle>
                      <mat-icon class="mat-icon-rtl-mirror">
                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                      </mat-icon>
                    </button>
                    {{node.code + ' ' + node.libelle}}
                    <button mat-icon-button type="button" color="success" (click)="addDroit(node)"><mat-icon>add</mat-icon></button>
                  </div>
                  <ul class="example-tree-nested-node">
                    <div *ngIf="treeControl.isExpanded(node)">
                      <ng-container matTreeNodeOutlet></ng-container>
                    </div>
                  </ul> 
                </li>
              </ul>
            </mat-nested-tree-node>
          </mat-tree>
        </mat-card>
      </div>
      
      <div class="col-md-9">
        <mat-card> 
          <app-table-droit [societes]="societesNode" [userForm]="form" (droitOutput)="deleteDroit($event)">
          </app-table-droit>
        </mat-card>
      </div>
    </div>
  </form>
</div>